import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';
import { AlertTriangle } from 'react-feather';
import { toast } from 'react-toastify';

const LicenseUsageBanner = ({ warnAssets = [] }) => {
    const { t } = useTranslation();
    useEffect(() => {
        if (!warnAssets || warnAssets.length === 0) return;
        const key = 'license-warn-toast-shown';
        if (sessionStorage.getItem(key)) return;
        toast.warn(t('License usage >80% on {{count}} asset(s). Review immediately.', { count: warnAssets.length }));
        sessionStorage.setItem(key, '1');
    }, [warnAssets, t]);

    if (!warnAssets || warnAssets.length === 0) return null;

    return (
        <Alert color='danger' className='d-flex align-items-center'>
            <AlertTriangle size={18} className='me-2' />
            <span>
                {t('License usage is above')} <strong>80%</strong> {t('on')}{' '}
                <strong>{warnAssets.map(a => a.property_mall_code).join(', ')}</strong>. {t('Plan a new PO to avoid consumption failures.')}
            </span>
        </Alert>
    );
};

export default LicenseUsageBanner;
